import { BASE } from "@/api/index";
import axios from "@/api/http";

const BASE_URL = BASE.PRO1;

/**
 * 总控-自定义属性列表
 * @param {*} params
 * @returns
 */
export function postCategoriesCustomFieldList(params = {}) {
  return axios.post(`${BASE_URL}/categories/custom/field/list`, params);
}

/**
 * 总控-保存自定义属性
 * @param {*} params
 * @returns
 */
export function postCategoriesCustomFieldSave(params = {}) {
  return axios.post(`${BASE_URL}/categories/custom/field/save`, params);
}

/**
 * 总控-一级品类
 * @param {*} params
 * @returns
 */
export function postCategoriesFirstList(params = {}) {
  return axios.post(`${BASE_URL}/categories/first/list`, params);
}

/**
 * 总控-一级品类
 * @param {*} params
 * @returns
 */
export function postCategoriesSecondList(params = {}) {
  return axios.post(`${BASE_URL}/categories/second/list`, params);
}

/**
 * 商品命名规范保存-250606
 * @param {*} params
 * @returns
 */
export function postCategoriesProductNameRuleSave(params = {}) {
  return axios.post(`${BASE_URL}/categories/product/name/rule/save`, params);
}

/**
 * 属性展示状态变更-20250606
 * @param {*} params
 * @returns
 */
export function postCategoriesCustomFieldStatus(params = {}) {
  return axios.post(`${BASE_URL}/categories/custom/field/status`, params);
}

/**
 * 属性排序接口-20250606
 * @param {*} params
 * @returns
 */
export function postCategoriesCustomFieldSort(params = {}) {
  return axios.post(`${BASE_URL}/categories/custom/field/sort`, params);
}

/**
 * 获取属性下特殊属性的下拉数据-20250606
 * @param {*} params
 * @returns
 */
export function postCategoriesCustomPropertList(params = {}) {
  return axios.post(`${BASE_URL}/categories/custom/property/list`, params);
}

/**
 * 获取公共属性-250701
 * @param {*} params
 * @returns
 */
export function getCategoriesNameRulePublicField(params = {}) {
  return axios.get(`${BASE_URL}/categories/name/rule/public/field`, {
    params,
  });
}
